import { render, staticRenderFns } from "./PedidoCuentaCrud.vue?vue&type=template&id=23011761"
import script from "./PedidoCuentaCrud.vue?vue&type=script&lang=js"
export * from "./PedidoCuentaCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports